import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 7 11"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M4.29 5.344.217 1.271A.73.73 0 0 1 .005.75.7.7 0 0 1 .217.217.72.72 0 0 1 .744 0q.31 0 .527.217l4.495 4.495a.83.83 0 0 1 .255.632.832.832 0 0 1-.256.633l-4.494 4.494a.73.73 0 0 1-.522.213.7.7 0 0 1-.532-.213A.72.72 0 0 1 0 9.944q0-.31.217-.527z"
    }, null, -1)
  ]))]))
}
export default { render: render }